module.exports = __webpack_public_path__ + "static/media/feature-secure.201521fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/login/marketing/feature-secure.svg
// module id = 13911
// module chunks = 0